import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { useWorkspace } from './WorkspaceContext';
import { useDispatch } from 'store';
import { getScopes, getTokenCount } from 'store/slices/profile'

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
    const dispatch = useDispatch();
    const { workspaceId, isWorkspaceLoading } = useWorkspace();
    const [permissions, setPermissions] = useState([]);
    const [isPermissionsLoading, setIsPermissionsLoading] = useState(true); // Add loading state
    const [error, setError] = useState(null);

    const fetchPermissions = useCallback(async () => {
        if (!workspaceId) {
            setPermissions([]);
            setIsPermissionsLoading(false);
            return;
        }

        setIsPermissionsLoading(true);
        try {
            dispatch(
                getScopes({
                    workspaceId
                }, (data) => {
                    setPermissions(data)
                })
            )
            dispatch(getTokenCount({workspaceId}))
            // if (!response.ok) {
            //     throw new Error(`Failed to fetch permissions: ${response.status}`);
            // }

            // const data = await response.json();
            // setPermissions(data);
            setError(null);
        } catch (err) {
            console.error("Error fetching permissions:", err);
            setError(err.message || "Failed to fetch permissions.");
            setPermissions([]); // Set to empty object on error
        } finally {
            setIsPermissionsLoading(false);
        }
    }, [workspaceId]);

    useEffect(() => {
        if (!isWorkspaceLoading) { // Prevent fetch before workspaceId is available
            fetchPermissions();
        }
    }, [workspaceId, isWorkspaceLoading, fetchPermissions]);

    const hasPermission = (permissionKey) => {
        return !!(permissions && permissions.includes(permissionKey)); //Safely check permission
    };

    const value = {
        permissions,
        hasPermission,
        isPermissionsLoading,
        error,
        refreshPermissions: fetchPermissions, // Provide a method to refresh permissions
    };

    return (
        <PermissionContext.Provider value={value}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermissions = () => {
    return useContext(PermissionContext);
};